import classNames from 'classnames';
import { ApplicationState } from '../../../utils/enums';
import { ActionIcon, FavouriteIcon, ImageIcon } from '@tymbe/ui-icons';
import { ApplicationData } from '../../../types/TymbeApi';
import { isDeleted, notDeleted } from './utils';

interface TymberAppStateIconProps {
  application: ApplicationData;
}
const TymberAppStateIcon = ({ application }: TymberAppStateIconProps) => {
  return (
    <div
      className={classNames(
        'flex justify-center items-center size-2.5 border-[1.5px] border-bg rounded-full absolute -right-1 -bottom-1 box-content',
        {
          'bg-green-700': application.state === ApplicationState.CONFIRMED,
        },
        {
          'bg-secondary-600':
            application.state === null &&
            notDeleted(application),
        },
        {
          'bg-orange-700':
            application.state === null &&
            isDeleted(application),
        },
        {
          'bg-red-700':
            application.state !== ApplicationState.CONFIRMED &&
            isDeleted(application),
        }
      )}
    >
      {application?.state === ApplicationState.CONFIRMED && (
        <FavouriteIcon name="check" className="size-2" />
      )}
      {application?.state === null &&
        notDeleted(application) && (
          <ActionIcon name="question_mark" className="size-2" />
        )}
      {application?.state === null &&
        isDeleted(application) && (
          <ImageIcon name="timelapse" className="size-2" />
        )}
      {application.state !== null &&
        isDeleted(application) && (
          <FavouriteIcon name="close" className="size-2" />
        )}
    </div>
  );
};

export default TymberAppStateIcon;
